<template>
  <v-container>
    <material-card>
      <v-layout px-3 slot="header">
        <v-flex my-4 pl-4 title align-center justify-center>Szablony wiadomości</v-flex>

        <v-spacer />

        <v-flex>
          <search />
        </v-flex>
      </v-layout>

      <v-layout text-xs-right>
        <v-flex>
          <check-permission permissions="MAIL_TEMPLATE.ADD">
            <v-btn large color="error" @click="showAddModal">DODAJ SZABLON</v-btn>
          </check-permission>
        </v-flex>
      </v-layout>

      <material-table
        entity-type="mail_template"
        :headers="table.headers"
        :actions="actions"
        :items="list"
        :total-count="count"
        @add="showAddModal"
        @edit="showEditModal($event.id)"
        @delete="showDeleteDialog($event.id)"
      />

      <material-dialog
        title="Potwierdź usunięcie"
        text="Czy na pewno chcesz usunąć szablon?"
        :show="!!idToDelete"
        :id="idToDelete"
        @close="hideDeleteDialog"
        @confirm="remove"
      />
    </material-card>

    <modal
      :show="showModal"
      :id="idToEdit"
      :edit="!!idToEdit"
      @close="hideModal"
      @save="saveTemplate"
      @update="updateTemplate"
    />
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

import MaterialCard from '@/components/material/Card';
import MaterialDialog from '@/components/material/Dialog';
import MaterialTable from '@/components/material/Table';
import Search from '@/components/material/table/Search';
import { listMixin } from '@/mixins/list';
import { DELETE_ACTION, EDIT_ACTION } from '@/utils/actions';
import Modal from './modals/template.modal';

// @vuese
// Wyświetlanie listy szablonów wiadomości
// @group MailTemplates
export default {
  mixins: [
    listMixin('mailTemplates', {
      listError: 'Wystąpił błąd podczas pobierania listy szablonów.',
      getError: 'Wystąpił błąd podczas pobierania danych szablonu.',
      added: 'Dodano szablon.',
      addError: 'Nie udało się dodać szablonu.',
      updated: 'Zaktualizowano dane szablonu.',
      updateError: 'Nie udało się zaktualizować danych szablonu.',
      deleted: 'Usunięto szablon.',
      deleteError: 'Nie udało się usunąć szablonu.'
    })
  ],
  components: {
    MaterialCard,
    MaterialDialog,
    MaterialTable,
    Modal,
    Search
  },
  methods: {
    // @vuese
    // Zapisuje szablon
    // @arg `template` - dane szablonu
    saveTemplate(template) {
      try {
        this.$store.dispatch('mailTemplates/add', { mailTemplate: this.deepClone(template) }).then(() => {
          this.notifySuccess('Dodano szablon.');
          this.hideModal();
        });
      } catch (error) {
        this.notifyError('Nie udało się dodać szablonu.');
      }
    },
    // @vuese
    // Aktualizuje obiekt
    // @arg `data` - dane Obiektu
    updateTemplate(data) {
      const id = data.id;
      data.id = undefined;
      try {
        this.$store.dispatch('mailTemplates/update', { id, mailTemplate: this.deepClone(data) }).then(() => {
          this.notifySuccess('Zaktualizowano dane szablonu.');
          this.hideModal();
        });
      } catch (error) {
        this.notifyError('Nie udało się zaktualizować danych szablonu.');
      }
    }
  },
  data() {
    return {
      table: {
        headers: [{ value: 'name', text: 'Nazwa szablonu', sortable: true }]
      },
      actions: [DELETE_ACTION, EDIT_ACTION]
    };
  }
};
</script>
